import { useState } from 'react';
import { Link } from 'react-router-dom';

const LeadNavigationButtons = ({ 
  currentLead, 
  isSideCart, 
  onDeleteLead 
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <>
      {/* Actions dropdown - positioned in top right of hero */}
      {!isSideCart && (
        <div className={`fixed top-20 right-4 z-50`}>
          <div className="relative">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="inline-flex items-center p-2 text-gray-600 hover:text-gray-800 bg-background hover:bg-background/110-300 rounded-full transition-colors"
            >
              <svg
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                />
              </svg>
            </button>

            {isDropdownOpen && (
              <div className="absolute right-0 mt-1 w-48 bg-background rounded-md ring-1 ring-black ring-opacity-5 z-50">
                <div className="py-1">
                  <Link
                    to={`/leads/${currentLead.id}/edit`}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-accent-teal-subtle transition-colors"
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    <svg
                      className="h-4 w-4 mr-3 text-gray-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      />
                    </svg>
                    Edit Lead
                  </Link>
                  {/* <button
                    onClick={() => {
                      onDeleteLead();
                      setIsDropdownOpen(false);
                    }}
                    className="flex items-center w-full px-4 py-2 text-sm text-red-700 hover:bg-red-50 transition-colors"
                  >
                    <svg
                      className="h-4 w-4 mr-3 text-red-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5-4h4m-4 0a1 1 0 00-1 1v1h6V3a1 1 0 00-1-1h-4zm-3 4h10"
                      />
                    </svg>
                    Delete Lead
                  </button> */}
                </div>
              </div>
            )}
          </div>

          {/* Backdrop to close dropdown when clicking outside */}
          {isDropdownOpen && (
            <div
              className="fixed inset-0 z-40"
              onClick={() => setIsDropdownOpen(false)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default LeadNavigationButtons;